import { Component, Injectable, Input, OnInit } from "@angular/core";
import { Title } from '@angular/platform-browser';
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from "../../../shared/alert/services/alert.service";
import { ScheduledType } from "../../../shared/models/ScheduledContent";
import { ScheduleService } from "../../../shared/services/schedule.service";
import { SignalBoService } from "../../../shared/services/signalbo.service";
import { UrlService } from "../../../shared/services/url.service";
import {
  EditorialMessageContent,
  getEventName,
  getPostUrl,
  getSignalValue,
} from "../../models/EditorialMessageContent";
import { SignalMessage } from "../../models/SignalMessage";
import { SignalsDeleteModalComponent } from "./signalsDeleteModal.component";
import { CronJob } from 'cron';
import { userQuestionAuthorId } from "../../utils/constants";
@Component({
  selector: "app-signals-messages",
  templateUrl: "../templates/signalsMessages.component.html",
  styleUrls: ["../styles/signalsMessages.component.css"],
})
@Injectable()
export class SignalsMessagesComponent implements OnInit {
  private _messages: SignalMessage[] = [];
  private _pageNum: number = 1;
  private _inProgress: boolean = false;
  private _canLoadMoreMessages: boolean = false;
  
  private dialogStyle = {
    hasBackdrop: true,
    backdropClass: "fxstreet-modal-backdrop",
    panelClass: "fxstreet-message-dialog-panel",
    position: { top: "60px" },
  };

  @Input() isScheduled: boolean;
  @Input() isUserQuestion: boolean = false;
  @Input() title: string;
  DashboardUrl = "";
  MessageType = "";
  BaseTitle = "";
  CronJob: CronJob;
  NewMessages = 0;

  constructor(
    private urlService: UrlService,
    private _dialog: MatDialog,
    private _alertService: AlertService,
    private _signalBoService: SignalBoService,
    private _scheduledService: ScheduleService,
    private titleService: Title,
    private router: ActivatedRoute,
    private route: Router,
  ) { }

  ngOnInit() {
    this.Init();
  }

  ngOnDestroy() {
    if(this.CronJob && this.CronJob.running) this.CronJob.stop();
    this.resetTitle()
  }

  async Init(): Promise<void> {
    this.isScheduled
      ? await this.loadScheduledMessage()
      : await this.loadMessages();

    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.MessageType = this.isScheduled ? "scheduled" : "messages";
    this.BaseTitle = this.titleService.getTitle();

    if (this.isUserQuestion) {
      
      window.addEventListener('blur', () => this.resetTitle());

      this.CronJob = new CronJob('*/3 * * * *', async () => {
        try {
          await this.refreshUserQuestionMessages();
        } catch (e) {
          console.error(e);
        }
      });
      if (!this.CronJob.running) this.CronJob.start();
    }
  }

  async loadMoreMessages(): Promise<void> {
    this._pageNum++;
    await this.loadMessages();
  }

  canLoadMoreMessages(): boolean {
    return this._canLoadMoreMessages;
  }

  deleteSignalMessage(message: SignalMessage) {
    const deleteMessageDialog = this._dialog.open(SignalsDeleteModalComponent, {
      ...this.dialogStyle,
      data: { message, isScheduled: this.isScheduled, tradePlan: null },
    });

    deleteMessageDialog.componentInstance.itemDeleted.subscribe((message) =>
      this.handleMessageDeleted(message)
    );
  }

  private resetTitle(){
    this.titleService.setTitle(this.BaseTitle);
    this.NewMessages = 0;
  }

  private async refreshUserQuestionMessages() {
    const response = await this._scheduledService
      .GetScheduleds<EditorialMessageContent>(ScheduledType.InsightMessage)
      .toPromise();

    const messages = []
    if (response) {
      response.forEach((scheduled) => {
        if ((this.isUserQuestion && scheduled.content.authorId === userQuestionAuthorId)) {
          const message = this.generateScheduledMessage(scheduled);
          messages.push(message);
        }
      });
    }

    this.sortDescByDate(messages);

    if (messages.length > this._messages.length) {
      this.NewMessages = this.NewMessages + (messages.length - this._messages.length);
      this.titleService.setTitle(` (${this.NewMessages}) ${this.BaseTitle}`);
    }

    this._messages = messages
  }

  private async loadMessages() {
    this._inProgress = true;

    const response = await this._signalBoService
      .GetEditorialMessages(this._pageNum)
      .toPromise();

    if (response) {
      response.items.forEach((message) => {
        const messageAlreadyLoaded = this._messages.some(
          (x) => x.id === message.id
        );
        if (!messageAlreadyLoaded) {
          this._messages.push(message);
        }
      });

      this._canLoadMoreMessages = this._messages.length < response.total;
    }
    this._inProgress = false;
  }

  private async loadScheduledMessage() {
    this._inProgress = true;

    const response = await this._scheduledService
      .GetScheduleds<EditorialMessageContent>(ScheduledType.InsightMessage)
      .toPromise();

    if (response) {
      response.forEach((scheduled) => {
        if ((!this.isUserQuestion && scheduled.content.authorId !== userQuestionAuthorId)
          || (this.isUserQuestion && scheduled.content.authorId === userQuestionAuthorId)) {
          const message = this.generateScheduledMessage(scheduled);
          this._messages.push(message);
        }
      });
    }
    this._inProgress = false;
    this.sortDescByDate(this._messages);
  }

  private generateScheduledMessage(scheduled) {
    const message = {
      id: scheduled.id,
      dateUtc: scheduled.dateUtc,
      content: scheduled.content,
    };
    (message.content.postLink = message.content
      ? getPostUrl(message.content)
      : undefined),
      (message.content.eventTitle = message.content
        ? getEventName(message.content)
        : undefined),
      (message.content.signalValue = message.content
        ? getSignalValue(message.content)
        : undefined);
    return message;
  }

  private handleMessageDeleted(message: SignalMessage) {
    const messageIndex = this._messages.indexOf(message);
    this._messages.splice(messageIndex, 1);

    this._alertService.add("success", "Message deleted successfully");

  }

  private sortAscByDate(array: SignalMessage[]): void {
    array.sort((a: SignalMessage, b: SignalMessage) => {
      return a.dateUtc.unix() - b.dateUtc.unix();
    });
  }

  private sortDescByDate(array: SignalMessage[]): void {
    array.sort((a: SignalMessage, b: SignalMessage) => {
      return b.dateUtc.unix() - a.dateUtc.unix();
    });
  }

  public get messages() {
    return this._messages;
  }

  public get inProgress(): boolean {
    return this._inProgress;
  }

  public get Title() {
    return this.title;
  }

}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsMessages.component.ts